module.exports = __webpack_public_path__ + "img/img-6.1de87f27.webp";